export default "__VITE_ASSET__BA$gOYrf__"